"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intl = require("@kyruus/intl");
var _button = _interopRequireDefault(require("@kyruus/button"));
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _styles = require("./styles");
const variants = {
  initial: {
    opacity: 0,
    scale: 0.1
  },
  enter: {
    opacity: 1,
    scale: 1
  },
  exit: {
    opacity: 0,
    scale: 0.1
  }
};
const NextBtn = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    onClick,
    type = '',
    form = ''
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.NextBtnContainer, {
    style: {
      display: 'inline-block'
    },
    "data-testid": "NextBtn",
    key: "apptinfo-next-btn",
    variants: variants,
    initial: "initial",
    animate: "enter",
    exit: "exit"
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    ref: ref,
    mode: "primary",
    onClick: onClick,
    type: type,
    form: form
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.next)));
});
NextBtn.displayName = 'NextBtn';
NextBtn.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  type: _propTypes.default.string,
  form: _propTypes.default.string
};
var _default = exports.default = NextBtn;
NextBtn.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "NextBtn",
  "props": {
    "type": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "form": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onClick": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};